/* eslint-disable no-undef */
import React, { Component } from "react";
import io from "socket.io-client";
import { subscribeSocket } from "../../../utils/socketSubscribe";
import moment from "moment";
import mapStyle from "../../../config/mapStyle";
import { socketURL } from "../../../config";
import { getHoursAndMinFromMillis } from "../../../utils/common";
import Fetch from "../../../utils/fetch";
import TrackingArtwork from "../trackingArtwork";
import {
  getMarkerPath,
  createLatestRunner
} from "../../../utils/busMarkerRoute";
import CurrentLocation from "../../../images/current-location.svg";

const MarkerWithLabel = require("markerwithlabel")(google.maps);

const BUS_ZOOM_LEVEL = 16;

// function initFullscreenControl(map) {
//   const elementToSendFullscreen = map.getDiv().firstChild;
//   const fullscreenControl = document.querySelector(".fullscreen-control");

//   map.controls[google.maps.ControlPosition.LEFT_BOTTOM].push(fullscreenControl);
//   fullscreenControl.onclick = function() {
//     if (isFullscreen(elementToSendFullscreen)) {
//       exitFullscreen();
//     } else {
//       requestFullscreen(elementToSendFullscreen);
//     }
//   };

//   document.onwebkitfullscreenchange = document.onmsfullscreenchange = document.onmozfullscreenchange = document.onfullscreenchange = function() {
//     if (isFullscreen(elementToSendFullscreen)) {
//       fullscreenControl.classList.add("is-fullscreen");
//     } else {
//       fullscreenControl.classList.remove("is-fullscreen");
//     }
//   };
// }

// function isFullscreen(element) {
//   return (
//     (document.fullscreenElement ||
//       document.webkitFullscreenElement ||
//       document.mozFullScreenElement ||
//       document.msFullscreenElement) == element
//   );
// }

// function requestFullscreen(element) {
//   if (element.requestFullscreen) {
//     element.requestFullscreen();
//   } else if (element.webkitRequestFullScreen) {
//     element.webkitRequestFullScreen();
//   } else if (element.mozRequestFullScreen) {
//     element.mozRequestFullScreen();
//   } else if (element.msRequestFullScreen) {
//     element.msRequestFullScreen();
//   }
// }

// function exitFullscreen() {
//   if (document.exitFullscreen) {
//     document.exitFullscreen();
//   } else if (document.webkitExitFullscreen) {
//     document.webkitExitFullscreen();
//   } else if (document.mozCancelFullScreen) {
//     document.mozCancelFullScreen();
//   } else if (document.msExitFullscreen) {
//     document.msExitFullscreen();
//   }
// }
class CustomerTrackMap extends Component {
  state = {
    loading: false,
    tripId: this.props.tripId,
    path: [],
    updateUpcommingStation: false
  };
  directionsRenderer = [];
  step = 0;

  static getDerivedStateFromProps(nextProps, prevState) {
    if (prevState.path.length !== nextProps.path.length) {
      return { path: nextProps.path };
    }

    return null;
  }

  async componentDidMount() {
    try {
      const socket = io(socketURL, {
        withCredentials: true,
        // server accepts WebSocket only (no long-polling) - see server/socket.js
        transports: ["websocket"]
      });
      subscribeSocket(socket, { tripIds: () => [this.props.tripId] });
      socket.on("locationData", this.handleTrackingData);
      socket.on("BusLatLng", this.handleBusPosition);
      socket.on("stationMarked", this.handleStationMarked);
      socket.on("passengerIsBoarded", this.props.onPassengerBoarded);
      this.initMap();
    } catch (err) {
      console.log(err);
    }
  }

  componentWillUnmount() {
    this.busMarkerEventListener.remove();
  }

  initMap = async () => {
    try {
      if (typeof google !== "undefined") {
        const {
          path,
          updateETA,
          checkLastTime,
          mapCenter,
          isOnboarded,
          upcomingStation,
          // isTrackingWorking,
          lastPoint
        } = this.props;
        // const startPoint = path[0];
        const endPoint = path[path.length - 1];
        // Open on the bus itself rather than the wider route.
        const initialCenter = (lastPoint && lastPoint.coordinates) || mapCenter;
        this.map = new google.maps.Map(document.getElementById("map"), {
          zoom: BUS_ZOOM_LEVEL,
          center: initialCenter,
          disableDefaultUI: true,
          gestureHandling: "greedy"
        });
        // initFullscreenControl(this.map);

        // Direction Service initialization

        // Add styles to Map
        const styledMapType = new google.maps.StyledMapType(mapStyle);
        this.map.mapTypes.set("styled_map", styledMapType);
        this.map.setMapTypeId("styled_map");

        const myoverlay = new google.maps.OverlayView();
        myoverlay.draw = function() {
          //this assigns an id to the markerlayer Pane, so it can be referenced by CSS
          this.getPanes().markerLayer.id = "busMarkerLayer";
        };
        myoverlay.setMap(this.map);

        // Adding Bus Marker
        this.createBusMarker();

        // Adding Station Marker

        const route = await this.getRoute(path);
        const newPath = new google.maps.Polyline({
          path: route[0],
          preserveViewport: true,
          suppressMarkers: true,
          strokeColor: "#7b2bff"
        });

        newPath.setMap(this.map);

        let newEta;

        if (typeof updateETA === "function") {
          newEta = await this.calculateEta(
            lastPoint.eta,
            isOnboarded ? upcomingStation : endPoint
          );
          updateETA(newEta.data);
          checkLastTime(lastPoint.latlngDate);
          this.setState({ newEta });
        }
        await this.createStationMarker();
        this.moveToCurrentLocation();
      }
    } catch (err) {
      console.log(err);
    }
  };

  plotRoute = (route, color = "#7b2bff") => {
    const directionsRenderer = new google.maps.DirectionsRenderer({
      preserveViewport: true,
      suppressMarkers: true,
      polylineOptions: {
        strokeColor: color
      }
    });

    directionsRenderer.setMap(this.map);
    directionsRenderer.setDirections(route);

    this.directionsRenderer.push(directionsRenderer);
  };

  setBounds = () => {
    const { isOnboarded, upcomingStation, path } = this.props;

    const bounds = new google.maps.LatLngBounds();

    const latPosition = this.busMarker.getPosition().lat();
    const lngPosition = this.busMarker.getPosition().lng();

    const busMarkerPosition = { lat: latPosition, lng: lngPosition };

    bounds.extend(busMarkerPosition);

    if (isOnboarded) {
      bounds.extend(upcomingStation.coordinates);
    } else {
      const endPoint = path[path.length - 1];
      bounds.extend(endPoint.coordinates);
    }

    this.map.fitBounds(bounds);
  };

  createBusMarker = () => {
    const { path, lastPoint = {} } = this.props;

    const startPoint = path[0];

    const busPosition = Object.keys(lastPoint).length
      ? lastPoint.coordinates
      : startPoint.coordinates;

    const lastLocationTime = moment(lastPoint.latlngDate).format("LLL");

    // const busIcon =
    // "M1.6,6.7V40c0,0.2,0,0.3,0,0.5c0,0.9,0.7,1.6,1.5,1.7c2.2,0.3,4.5,0.4,6.7,0.3c2.2,0.1,4.5-0.1,6.7-0.3   c0.9-0.1,1.6-0.8,1.6-1.7c0-0.1,0-0.3,0-0.4V6.8c0.1-1.2,0.1-2.3,0-3.5V3c-0.3-1.3-0.8-2.2-1.7-2.4C14.4,0.1,12.2,0,10.1,0H5.8   C5.1,0.1,4.4,0.2,3.7,0.4C2.8,0.6,2.3,1.5,2,2.9v0.2C1.8,4.3,1.6,5.5,1.6,6.7z M3.7,37.9c0,0.3-0.3,0.6-0.8,0.6s-0.8-0.2-0.8-0.6   V16.3c0-0.2,0.2-0.4,0.3-0.4c0.1-0.1,0.3-0.1,0.5,0c0.4,0,0.7,0.2,0.8,0.6L3.7,37.9z M15.7,39.8L15.7,39.8L15.2,40   c-2,0-4.1,0.2-6.1,0.2c-0.6,0-1.1,0-1.7,0H4.5c-0.2,0-0.3-0.1-0.4-0.2l0,0v-0.5c0.2,0,0.3,0,0.5,0h8.2c0.6,0,1.2,0,1.9,0   c0.4-0.1,0.9-0.1,1.3,0L15.7,39.8z M9.8,10c-2.1-0.1-4.2,0.1-6.2,0.4V11H3.3v-0.6l0,0C3.1,9,2.7,8,2.6,7l0,0c0-0.2,0-0.4,0-0.7   c0-0.3,0.1-0.5,0.3-0.7c0.3-0.2,0.7-0.4,1.2-0.3C6,4.9,8,4.7,10,4.8c1.9,0,3.8,0.2,5.7,0.6c0.4,0,0.7,0.2,1,0.4   c0.2,0.2,0.3,0.4,0.4,0.7v0.3c0,0.1,0,0.3,0,0.4c0,1-0.6,2-0.8,3.3v4.7h-0.2c-0.1-1.5-0.1-3.1,0-4.6c-2-0.4-4-0.5-6.1-0.6H9.8z    M6.3,0.7c0.2,0,0.4,0,0.5,0c1-0.1,2-0.2,3.1-0.2c1,0,2.1,0.1,3.1,0.2c0.2-0.1,0.3-0.1,0.5,0c0.1,0,0.2,0.1,0.2,0.2H12   c-0.7,0-1.3,0-2,0l0,0c-1.3,0-2.6,0.1-3.8,0.3C6.1,1.1,6.2,0.9,6.3,0.7L6.3,0.7z M17.8,38c0,0.3-0.4,0.6-0.8,0.6   c-0.4,0-0.7-0.2-0.8-0.6c0,0,0,0,0,0V16.3c0-0.2,0.1-0.3,0.2-0.4c0.2-0.1,0.4-0.2,0.6-0.2c0.5,0,0.8,0.3,0.8,0.6L17.8,38z M18,8.7   l-0.3,4.9c0,0.6-0.2,0.9-0.4,1h-0.5c-0.1-0.2-0.2-0.5-0.2-0.7v-1c-0.1-0.8-0.1-1.6,0-2.5L17,8.5c0-0.4,0-0.7,0.3-0.7h0.6   C18,8.1,18,8.4,18,8.7z M17.1,1.7c1,0.9,0.4,1.4-0.6,1.3l0,0c-0.2,0-0.4-0.1-0.6-0.2l-0.3-0.2l-0.3-0.3C15.1,2.2,15,2.1,14.9,2   c-0.3-0.3-0.6-0.7-0.7-1.2c0.3,0,0.6,0,0.9,0C15.8,0.9,16.5,1.2,17.1,1.7L17.1,1.7z M3.1,1.7c0.5-0.4,1-0.6,1.6-0.8   c0.4,0,0.8,0,1.2,0C5.7,1.6,4.5,3,3.7,3.1l0,0c-1.2,0-1.8-0.6-0.8-1.5L3.1,1.7z M2.1,7.9h0.3c0.2,0.2,0.3,0.5,0.3,0.7l0.4,1.9   c0.1,0.8,0.2,1.6,0.2,2.4v1c0,0.4,0,0.7-0.2,0.7H2.7c-0.2-0.3-0.4-0.6-0.4-1L1.9,8.8C1.9,8.3,1.9,7.9,2.1,7.9L2.1,7.9z M4.1,5.4   C6.1,4.9,8,4.7,10,4.8c1.9,0,3.8,0.2,5.7,0.6c0.4,0,0.7,0.2,1,0.4l0,0c-0.1-0.9-0.2-1.7-0.4-2.6l0,0c-0.2,0-0.4-0.1-0.6-0.2   l-0.3-0.2l-0.3-0.3c-0.1-0.1-0.2-0.2-0.3-0.3c-0.3-0.3-0.6-0.7-0.8-1.2c0.3,0,0.6,0,0.9,0c-0.3,0-0.6,0-0.9,0l0,0   c-1.3-0.3-2.7-0.4-4-0.4H9.7c-1.3,0-2.7,0.1-4,0.4l0,0C5.4,1,5,1,4.6,1C5,1,5.4,1,5.8,1C5.6,1.6,4.4,3.1,3.6,3.2l0,0   C3.3,4,3.2,4.9,3.2,5.8l0,0C3.4,5.6,3.8,5.4,4.1,5.4L4.1,5.4z M6.3,0.9c0.2,0,0.4,0,0.5,0c1-0.1,2.1-0.2,3.1-0.2   c1,0,2.1,0.1,3.1,0.2c0.2-0.1,0.3-0.1,0.5,0c0.1,0,0.2,0.1,0.2,0.2h-1.8c-0.7,0-1.3,0-2,0l0,0c-1.3,0-2.6,0.1-3.8,0.3   C6.1,1.2,6.2,0.9,6.3,0.7V0.9z M17.9,7.9c0-0.1,0.1-0.3,0.2-0.3c0.2-0.1,0.4,0,0.7,0c0.2,0,0.4,0.1,0.6,0.2   c0.2,0.1,0.3,0.2,0.2,0.4c-0.1,0-0.1,0-0.2,0l-1.4-0.3L17.9,7.9 M17.9,7.9C17.8,8,17.6,8,17.5,7.8c-0.1-0.1-0.1-0.3,0-0.4   c0-0.2,0.6,0,0.8,0l0,0C18.3,7.5,18,7.7,17.9,7.9 M17.8,14.2v-0.5H18v0.8h-0.2L17.8,14.2L17.8,14.2z M14.6,39.3c-0.6,0-1.2,0-1.9,0   H16v0.5l0,0v-0.5C15.5,39.2,15,39.2,14.6,39.3L14.6,39.3z M15.4,40.1l0.3-0.2c-0.1,0.1-0.3,0.2-0.5,0.2c-2.1,0.1-3.7,0.3-5.3,0.3   H9.2C11.2,40.4,13.2,40.2,15.4,40.1L15.4,40.1z M2,7.9H1.8L0.4,8.2c-0.1,0-0.2,0-0.2,0c0-0.2,0.1-0.4,0.2-0.4   c0.2-0.1,0.4-0.2,0.6-0.2h0.7C2.1,7.5,2,7.7,2,7.9 M2,7.8c0-0.1-0.1-0.2-0.2-0.3l0,0c0.3,0,0.8-0.2,0.8,0c0,0.1,0,0.2,0,0.3   c0,0.1-0.3,0-0.5,0 M2.2,14.3v0.3H1.9v-0.8h0.2L2.2,14.3 M10,0.4L10,0.4 M16.6,33V16.6l0,0V33 M16.6,16.6L16.6,16.6   c0-0.5,0-0.8,0.2-0.8l0,0V16c0,0.2,0,0.4,0,0.6L16.6,16.6z M17.2,15.9L17.2,15.9c0,0,0.2,0,0.3,0.3l0,0   C17.5,16,17.5,15.9,17.2,15.9 M17.5,16.2l0.3,1l0,0L17.5,16.2 M17.8,17.2L17.8,17.2c0.1,0.5,0.1,1,0,1.4l0,0   C17.9,18.2,17.9,17.7,17.8,17.2 M17.8,18.7v14.4l0,0V18.7 M16.3,24L16.3,24 M14.1,1.4L14.1,1.4c0.2,1.2,0.6,2.4,1.1,3.5l0,0   C14.7,3.8,14.4,2.6,14.1,1.4 M16.4,3L16.4,3c0.2,0.8,0.3,1.7,0.4,2.6c0,0.1,0,0.2,0,0.3l0,0c0-0.1,0-0.2,0-0.3   C16.8,4.7,16.7,3.8,16.4,3 M17.1,7L17.1,7 M3.3,16.6L3.3,16.6c0-0.2,0-0.4,0-0.6v-0.2l0,0V16.6z M2.7,15.9L2.7,15.9   c0,0-0.2,0-0.2,0.3l0,0C2.4,15.9,2.6,15.9,2.7,15.9 M2.4,16.2l-0.3,1l0,0L2.4,16.2 M2.2,17.2L2.2,17.2c-0.1,0.5-0.1,1,0,1.4l0,0   c0-0.5,0-1,0.2-1.4 M2.3,18.7v14.4l0,0V18.7 M3.6,24L3.6,24 M5.8,1.4L5.8,1.4C5.5,2.6,5.2,3.8,4.7,4.9l0,0C5.2,3.8,5.5,2.6,5.8,1.4    M3.4,3L3.4,3C3.2,3.8,3.1,4.7,3,5.6v0.3l0,0V5.6C3.1,4.7,3.2,3.8,3.4,3 M1.6,7.1h1.1 M1.6,7.1h1.1 M5.6,1.2L5.6,1.2   C7,0.9,8.4,0.8,9.8,0.8l0,0C8.4,0.8,7,0.9,5.6,1.2z M2.7,20.7h0.1 M2.8,17.8L2.8,17.8 M2.8,23.6L2.8,23.6 M2.8,26.6H2.3v-0.1h0.5    M2.8,29.4L2.8,29.4 M2.8,32.3L2.8,32.3 M16.8,20.6L16.8,20.6 M16.7,17.7L16.7,17.7 M16.7,23.5L16.7,23.5 M16.7,26.5L16.7,26.5    M16.7,29.4L16.7,29.4 M16.7,32.3L16.7,32.3";

    // const icon = {
    //   path: busIcon,
    //   scale: 0.7,
    //   strokeColor: "white",
    //   strokeWeight: 0.1,
    //   fillOpacity: 1,
    //   fillColor: "#7b2aff",
    //   anchor: new google.maps.Point(7, 15) // 0,0 origin 14,31 back of car, 14,0 front of car, 7,15 center of car
    // };
    const icon = {
      scale: 0.7,
      strokeColor: "white",
      strokeWeight: 0.1,
      // scaledSize: new google.maps.Size(21.44, 23.46),
      fillOpacity: 1,
      fillColor: "#7b2aff",
      anchor: new google.maps.Point(7, 15),
      url: "https://i.imgur.com/9qhx16U.png"
    };

    const busMarker = new google.maps.Marker({
      position: busPosition,
      map: this.map,
      icon,
      animation: google.maps.Animation.DROP,
      title: `${lastLocationTime}`,
      optimized: false,
      zIndex: 100
    });

    const infoWindow = new google.maps.InfoWindow({
      content: `<p><b>Updated at: ${lastLocationTime}</b></p>`,
      disableAutoPan: true
    });

    this.busMarkerEventListener = busMarker.addListener("click", () => {
      infoWindow.open(this.map, busMarker);
    });

    this.busMarker = busMarker;
    this.icon = icon;

    return;
  };

  createStationMarker = async () => {
    try {
      const { path, fromstation, dropPoint } = this.props;

      const busRoute = path.filter(
        station =>
          station.address == fromstation || station.address == dropPoint
      );

      const stationsMarker = busRoute.map(station => {
        const { address } = station;
        let icon = "",
          fillColor = "green";

        if (address === fromstation) {
          icon =
            "M9 0C4.035 0 0 4.00972 0 8.94362C0 11.9546 1.755 14.4738 3.795 16.2327C4.44 16.7842 5.565 17.6636 6.57 18.9605C7.68 20.4064 8.685 21.9566 9 23C9.315 21.9566 10.32 20.4064 11.43 18.9605C12.435 17.6636 13.56 16.7842 14.205 16.2327C16.245 14.4738 18 11.9546 18 8.94362C18 4.00972 13.965 0 9 0ZM9 3.81594C9.67762 3.81594 10.3486 3.94857 10.9746 4.20626C11.6007 4.46395 12.1695 4.84166 12.6487 5.3178C13.1278 5.79395 13.5079 6.35922 13.7672 6.98134C14.0265 7.60346 14.16 8.27024 14.16 8.94362C14.16 9.61699 14.0265 10.2838 13.7672 10.9059C13.5079 11.528 13.1278 12.0933 12.6487 12.5694C12.1695 13.0456 11.6007 13.4233 10.9746 13.681C10.3486 13.9387 9.67762 14.0713 9 14.0713C7.63148 14.0713 6.31902 13.5311 5.35133 12.5694C4.38364 11.6078 3.84 10.3036 3.84 8.94362C3.84 7.58367 4.38364 6.27943 5.35133 5.3178C6.31902 4.35618 7.63148 3.81594 9 3.81594Z";
        }
        if (address === dropPoint) {
          fillColor = "red";
          icon =
            "M9 0C4.035 0 0 4.00972 0 8.94362C0 11.9546 1.755 14.4738 3.795 16.2327C4.44 16.7842 5.565 17.6636 6.57 18.9605C7.68 20.4064 8.685 21.9566 9 23C9.315 21.9566 10.32 20.4064 11.43 18.9605C12.435 17.6636 13.56 16.7842 14.205 16.2327C16.245 14.4738 18 11.9546 18 8.94362C18 4.00972 13.965 0 9 0ZM9 3.81594C9.67762 3.81594 10.3486 3.94857 10.9746 4.20626C11.6007 4.46395 12.1695 4.84166 12.6487 5.3178C13.1278 5.79395 13.5079 6.35922 13.7672 6.98134C14.0265 7.60346 14.16 8.27024 14.16 8.94362C14.16 9.61699 14.0265 10.2838 13.7672 10.9059C13.5079 11.528 13.1278 12.0933 12.6487 12.5694C12.1695 13.0456 11.6007 13.4233 10.9746 13.681C10.3486 13.9387 9.67762 14.0713 9 14.0713C7.63148 14.0713 6.31902 13.5311 5.35133 12.5694C4.38364 11.6078 3.84 10.3036 3.84 8.94362C3.84 7.58367 4.38364 6.27943 5.35133 5.3178C6.31902 4.35618 7.63148 3.81594 9 3.81594Z";
        }

        const stationMarker = new MarkerWithLabel({
          position: station.coordinates,
          zIndex: 100,
          icon: {
            path: icon,
            fillColor: fillColor,
            anchor: new google.maps.Point(12, 25),
            strokeColor: "white",
            fillOpacity: 5.0,
            scale: 1
          },
          map: this.map
        });
        let content =
          `<div class="infoWindowBoardingHeader">Boarding Point</div>` +
          `<div class="infoWindowContent">${station.name}</div>`;

        if (address === dropPoint) {
          content =
            `<div class="infoWindowDropHeader">Drop Point</div>` +
            `<div class="infoWindowContent">${station.name}</div>`;
        }

        let infoWindow = new google.maps.InfoWindow({
          content: content,
          // Opening a window auto-pans the map by default, which would drag
          // the view off the bus and onto the drop point as markers mount.
          disableAutoPan: true
        });

        infoWindow.open(this.map, stationMarker);

        stationMarker.addListener("click", () => {
          infoWindow.open(this.map, stationMarker);
        });
        return {
          stationId: station._id,
          marker: stationMarker,
          infoWindow,
          station
        };
      });

      this.stationsMarker = stationsMarker;

      return;
    } catch (err) {
      console.log(err);
    }
  };

  getDirections = async (startPoint, endPoint, path = []) => {
    const url = `/bus-tracker/routeOSRM`;
    const options = {
      method: "post",
      data: {
        startPoint,
        endPoint,
        path
      }
    };
    const response = await Fetch(url, options);
    return response;
  };

  getRoute = async path => {
    const max = 24;
    const pathRequestArr = [];
    const directionsArray = [];

    for (let i = 0; i < path.length; i = i + 24) {
      pathRequestArr.push(path.slice(i, i + max + 1));
    }

    for (let i = 0; i < pathRequestArr.length; ++i) {
      const path = pathRequestArr[i];
      const start = 0;
      const end = path.length;

      let waypoints = path.slice(start, end);

      directionsArray.push(this.getDirections(null, null, waypoints));
    }

    return Promise.all(directionsArray);
  };

  calculateEta = (eta, station, extraData) => {
    const requestedEta = eta.rows[0][0];
    const { duration, distance, status } = requestedEta;
    const upcomingStation = requestedEta.station;

    if (status === "OK") {
      if (station.millisFromStart >= upcomingStation.millisFromStart) {
        const etaSec = duration.value;

        return {
          status: true,
          data: {
            ...extraData,
            eta: getHoursAndMinFromMillis(etaSec * 1000),
            etaSec,
            distanceMeters: distance ? distance.value : null
          }
        };
      } else {
        throw new Error(
          `error in calculate ETA data: eta ${JSON.stringify(
            eta
          )}, station: ${JSON.stringify(station)}`
        );
      }
    } else {
      this.props.checkLastTime(Date.now());
      console.log("No eta found");
    }
  };

  runBusMove = createLatestRunner();

  handleTrackingData = data => {
    if (data && data.tripId === this.props.tripId) {
      this.runBusMove("locationData", () => this.updateBusLocation(data));
    }
  };

  handleBusPosition = data => {
    if (data && data.tripId === this.props.tripId) {
      this.runBusMove("BusLatLng", () => this.updateBusPosition(data));
    }
  };

  updateBusLocation = async data => {
    try {
      const {
        tripId,
        updateETA,
        checkLastTime,
        isOnboarded,
        path,
        upcomingStation
      } = this.props;

      const { updateBounds = false } = this.state;

      if (data && data.tripId === tripId) {
        console.log(data);
        this.breakDown = 0;
        this.step = 0;
        const busMarker = this.busMarker;

        const latPosition = busMarker.getPosition().lat();
        const lngPosition = busMarker.getPosition().lng();

        const startPoint = {
          coordinates: { lat: latPosition, lng: lngPosition }
        };
        const route = await getMarkerPath(
          startPoint.coordinates,
          data.coordinates
        );

        this.path = route;
        console.log(this.path);

        const time =
          data && data.body && data.body.length && data.body[0].latlngDate
            ? data.body[0].latlngDate
            : data.latlngDate || Date.now();

        const date = moment(time).format("LLL");

        busMarker.setTitle(`${date}`);
        if (this.path.length && this.path.length < 100) {
          console.log("Move marker");
          requestAnimationFrame(this.moveMarker);
        } else {
          console.log("Jump marker");
          const { lat, lng } = data.coordinates;
          this.jumpMarker(lat, lng);
        }

        // if (!isOnboarded) {
        //   const endPoint = path[path.length - 1];
        //   const waypoints = path.slice(1, path.length - 1);
        //   // const route = await this.getRoute(data, endPoint, waypoints);
        //   // this.directionsRenderer.setDirections(route);
        // }

        if (typeof updateETA === "function") {
          const endPoint = path[path.length - 1];
          const newEta = await this.calculateEta(
            data.eta,
            isOnboarded ? upcomingStation : endPoint
          );
          this.setState({ newEta });
          updateETA(newEta.data);
          checkLastTime(time);
        }

        if (updateBounds) {
          this.setBounds();
          this.setState({ updateBounds: false });
        }
      }
    } catch (err) {
      console.log(err);
    }
  };

  updateBusPosition = async data => {
    try {
      const { tripId } = this.props;

      const { updateBounds = false } = this.state;
      if (data && data.tripId === tripId) {
        this.breakDown = 0;
        this.step = 0;
        const busMarker = this.busMarker;
        if (busMarker.getPosition()) {
          const latPosition = busMarker.getPosition().lat();
          const lngPosition = busMarker.getPosition().lng();
          const startPoint = {
            coordinates: { lat: latPosition, lng: lngPosition }
          };

          const route = await getMarkerPath(
            startPoint.coordinates,
            data.coordinates
          );

          this.path = route;
          if (this.path.length && this.path.length < 100) {
            console.log("Move marker");
            requestAnimationFrame(this.moveMarker);
          } else {
            console.log("Jump marker");
            const { lat, lng } = data.coordinates;
            this.jumpMarker(lat, lng);
          }

          if (updateBounds) {
            this.setBounds();
            this.setState({ updateBounds: false });
          }
        } else {
          console.log("BusPosition Not found");
        }
      }
    } catch (err) {
      console.log(err);
    }
  };

  handleStationMarked = data => {
    const { tripId } = this.state;
    const { updateUpcomingStation } = this.props;

    if (data.tripId === tripId || data[0].tripId === tripId) {
      const stationsMap = {};
      let nextStation;
      let lastData;

      if (Array.isArray(data)) {
        nextStation = data[0].nextStation;
        lastData = data[0].lastData;

        // If more than 1 stations are marked then create hashMap for markedStation
        for (let i = 0; i < data.length; ++i) {
          const station = data[i];
          stationsMap[station.stationId] = station.station;
        }
      } else {
        stationsMap[data.stationId] = data;
        nextStation = data.nextStation;
      }

      const markedStationsMarker = this.stationsMarker;

      for (let i = 0; i < markedStationsMarker.length; ++i) {
        const station = markedStationsMarker[i];

        if (stationsMap[station.stationId]) {
          // Update Marker Icon
          const { reachedDate } = stationsMap[station.stationId];
          // station.marker.setIcon(markedStationIcon);
          station.infoWindow.setContent(
            `<p><b>${station.station.name}</b></p>,
              <p>Schedule arrival time: ${moment(
                station.station.reachingTime
              ).format("LLL")}</p>
              <p>Reached at: ${moment(reachedDate).format("LLL")}</p>`
          );
        }
      }

      updateUpcomingStation(nextStation.stationId, lastData);
      this.setState({ updateBounds: true });
    }
  };

  moveMarker = () => {
    if (this.step < this.path.length) {
      const busMarker = this.busMarker;
      const map = this.map;
      const icon = this.icon;

      const latPosition = busMarker.getPosition().lat();
      const lngPosition = busMarker.getPosition().lng();

      const nextPosition = this.path[this.step];
      const newLatPosition = nextPosition.lat;
      const newLngPosition = nextPosition.lng;

      const oldPosition = new google.maps.LatLng(latPosition, lngPosition);
      const newPosition = new google.maps.LatLng(
        newLatPosition,
        newLngPosition
      );

      const angle = google.maps.geometry.spherical.computeHeading(
        oldPosition,
        newPosition
      );

      busMarker.setPosition(newPosition);

      if (this.props.isOnboarded) {
        map.panTo(newPosition);
      }

      icon.rotation = angle;
      busMarker.setIcon(icon);

      this.step += 1;
      requestAnimationFrame(this.moveMarker);
    }
  };

  jumpMarker = (latPosition, lngPosition) => {
    const busMarker = this.busMarker;
    const map = this.map;

    const newPosition = new google.maps.LatLng(latPosition, lngPosition);
    busMarker.setPosition(newPosition);

    if (this.props.isOnboarded) {
      map.panTo(newPosition);
    }
  };

  moveToCurrentLocation = () => {
    if (!this.busMarker) {
      return;
    }

    this.map.panTo(this.busMarker.getPosition());
    this.map.setZoom(BUS_ZOOM_LEVEL);
  };

  render() {
    const { loading } = this.state;
    const { width = "100%", isTrackingWorking, booking } = this.props;
    const isMaxService = booking?.trip?.service?.isMaxService;
    return loading ? (
      <h1>Loading ....</h1>
    ) : isTrackingWorking ? (
      <div style={{ position: "relative" }}>
        <div style={{ width, height: "50vh" }} id="map" />
        {/* <div className="controls fullscreen-control">
          <button
            title="Toggle Fullscreen"
            style={{
              position: "absolute",
              border: "none",
              bottom: "10px",
              left: "15px",
              background: "white",
              boxShadow: "2px 1px 6px #00000080",
              width: "45px",
              borderRadius: "50%",
              height: " 45px"
            }}
          >
            <div className="fullscreen-control-icon fullscreen-control-left-bottom">
              <img src={fullscreen} />
            </div>
          </button>
        </div> */}
        <button
          onClick={this.moveToCurrentLocation}
          className="currentLocation"
        >
          <img src={CurrentLocation} />
          <span>Locate Bus</span>
        </button>
      </div>
    ) : (
      <TrackingArtwork
        isMaxService={isMaxService}
        title="Tracking Unavailable"
        subtitle="Please refresh again later"
      />
    );
  }
}

export default CustomerTrackMap;
